/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IValueProps {
    title: string;
    description?: string;
    image?: string;
}

export interface IValueSectionProps {
    valueSectionId?: string;
    valueLabel?: string;
    valueDescription?: string;
    values?: IValueProps[];
}

export const ValueSection = ({
    valueSectionId,
    valueLabel,
    valueDescription,
    values
}: IValueSectionProps) => {
    const _renderValueLabel = () => {
        if (valueLabel) {
            return <h2>{valueLabel}</h2>;
        }
    };
    const _rendervalueDescription = () => {
        if (valueDescription) {
            return <p>{valueDescription}</p>;
        }
    };

    const _renderHeader = () => {
        if (valueLabel || valueDescription) {
            return (
                <header className={"section-header"}>
                    {_renderValueLabel()}
                    {_rendervalueDescription()}
                </header>
            );
        }
    };

    const _renderValues = () => {
        let _comp: any = [];
        const delay = 200;
        const _getColClassName = () => {
            if (values?.length === 1) {
                return "col-lg-12";
            } else if (values?.length === 2) {
                return "col-lg-6";
            }
            return "col-lg-4";
        };
        if (values) {
            values?.forEach((_val, index) => {
                let _aos_props: any = {};
                if (!isIOS) {
                    _aos_props = {
                        "data-aos": "fade-up",
                        "data-aos-delay": String(delay * (index + 1))
                    };
                }
                _comp.push(
                    <div
                        key={`landing-page-values-${index}`}
                        className={_getColClassName()}
                        {..._aos_props}
                    >
                        <div className={"box"}>
                            {_val?.image && (
                                <img
                                    src={_val.image}
                                    className={"img-fluid"}
                                    alt={""}
                                />
                            )}
                            {_val?.title && <h3>{_val?.title}</h3>}
                            {_val?.description && <p>{_val?.description}</p>}
                        </div>
                    </div>
                );
            });
        }
        return _comp;
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    return (
        <section id={valueSectionId} className="values">
            <div className="container" {..._aos_props}>
                {_renderHeader()}
                <div className="row">{_renderValues()}</div>
            </div>
        </section>
    );
};

ValueSection.defaultProps = {
    valueSectionId: "values"
};
